export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/applause-icon.png?f4925efc152c51192b1a2cc8f7b8b803";